<template>
  <!-- A small status or category pill: tags, the draft marker, colour counts,
       request status codes. A tint of the tone with a matching hairline, so
       badges sit on any dark surface without shouting. `light` is for the white
       info panel of a swatch card. -->
  <span
    class="inline-flex items-center gap-1 whitespace-nowrap rounded-full font-semibold ring-1 ring-inset"
    :class="[TONES[tone], SIZES[size]]"
  >
    <slot />
  </span>
</template>

<script setup>
defineProps({
  tone: { type: String, default: 'neutral' },
  size: { type: String, default: 'sm' },
})

const TONES = {
  neutral: 'bg-white/5 text-gray-400 ring-white/10',
  brand: 'bg-indigo-500/15 text-indigo-300 ring-indigo-500/25',
  success: 'bg-emerald-500/15 text-emerald-300 ring-emerald-500/25',
  warning: 'bg-amber-400/10 text-amber-300 ring-amber-400/30',
  danger: 'bg-red-500/15 text-red-300 ring-red-500/25',
  light: 'bg-gray-100 text-gray-500 ring-gray-200',
}

const SIZES = {
  xs: 'px-1.5 py-0.5 text-2xs',
  sm: 'px-2 py-0.5 text-xs',
}
</script>
